export enum ReportType {
    IP_SUMMARY = 'ipsummary',
    VULNS_SUMMARY = 'vulnssummary',
    VULNS_LIST = 'vulnslist',
    SCAN_LIST = 'scanlist'
}
